let language = {
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_TITLE:"上传文件",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_TABLE_HEAD_IMAGE:"图像",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_TABLE_HEAD_INFO:"信息",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_TABLE_HEAD_STATUS:"状态",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FILE_NAME:"名称:",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FILE_TYPE:"类型:",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FILE_SIZE:"大小:",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FILE_MESSAGE:"消息:",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_CANCLE_BTN:"取消",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_OK_BTN:"确定",

    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_SUCCESS: "成功",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FAIL: "失败",
};

export { language }